export * from './Pdf';



// WEBPACK FOOTER //
// ./src/components/pdf/index.ts